import Http from '../../common/services/Http';
import { Paged } from '../common/types/Page';
import { ApiTokenSearchCriteria } from './models/ApiTokenSearchCriteria';
import { ApiTokenDto } from './models/ApiTokenDto';

class ApiTokensService {

    public getList(criteria: ApiTokenSearchCriteria) {
        return Http.get<Paged<ApiTokenDto>>('apiTokens', criteria);
    }
        
    public getById(id: string) {
        return Http.get<ApiTokenDto>('apiTokens/' + id);
    }

    public create() {
        return Http.post<string>('apiTokens',{});
    }


    public remove(model: ApiTokenDto) {
        return Http.put('apiTokens/deactivate', model);
    }
}

export default new ApiTokensService();